import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import EsperienzaShop from './pages/EsperienzaShop';
import ChiSiamo from './pages/ChiSiamo';
import DiventaPartner from './pages/DiventaPartner';
import Candidatura from './pages/Candidatura';
import CandidaturaLanding from './pages/CandidaturaLanding';
import Presentazione from './pages/Presentazione';
import Segnalazione from './pages/Segnalazione';
import SegnalazioneStato from './pages/SegnalazioneStato';
import DettaglioProdotto from './pages/DettaglioProdotto';
import ClienteLogin from './pages/ClienteLogin';
import ClienteRegister from './pages/ClienteRegister';
import ClienteForgotPassword from './pages/ClienteForgotPassword';
import ClienteResetPassword from './pages/ClienteResetPassword';
import AreaRiservata from './pages/AreaRiservata';
import Preferiti from './pages/Preferiti';
import Carrello from './pages/Carrello';
import Termini from './pages/Termini';
import Privacy from './pages/Privacy';
import ModelloBusiness from './pages/ModelloBusiness';
import CarrelloFab from './components/CarrelloFab';
import Preloader from './components/Preloader';
import Navbar from './components/Navbar';
import DiventaCloser from './pages/DiventaCloser';
import Contatti from './pages/Contatti';

export default function ClienteApp() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Preloader breve solo al primo ingresso sessione
    const seen = sessionStorage.getItem('mang_preloader_done');
    if (seen) {
      setLoading(false);
      return undefined;
    }
    const timer = setTimeout(() => {
      sessionStorage.setItem('mang_preloader_done', '1');
      setLoading(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Preloader />;

  return (
    <div className="cliente-section">
      <Navbar />
      <CarrelloFab />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/catalogo" element={<EsperienzaShop />} />
        <Route path="/catalogo/:id" element={<EsperienzaShop />} />
        <Route path="/diventa-closer" element={<DiventaCloser />} />
        <Route path="/programma-closer" element={<Navigate to="/diventa-closer" replace />} />
        <Route path="/esperienza" element={<Navigate to="/catalogo" replace />} />
        <Route path="/esperienza/*" element={<Navigate to="/catalogo" replace />} />
        <Route path="/chi-siamo" element={<ChiSiamo />} />
        <Route path="/progetto" element={<Navigate to="/diventa-partner" replace />} />
        <Route path="/diventa-partner" element={<DiventaPartner />} />
        <Route path="/candidatura" element={<Candidatura />} />
        <Route path="/candidatura/:slug" element={<CandidaturaLanding />} />
        <Route path="/presentazione" element={<Presentazione />} />
        <Route path="/segnalazione" element={<Segnalazione />} />
        <Route path="/segnalazione/stato/:token" element={<SegnalazioneStato />} />
        <Route path="/carrello" element={<Carrello />} />
        <Route path="/prodotto/:id" element={<DettaglioProdotto />} />
        <Route path="/termini" element={<Termini />} />
        <Route path="/termini-e-condizioni" element={<Navigate to="/termini" replace />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/per-partner" element={<ModelloBusiness />} />
        <Route path="/modello-business" element={<Navigate to="/per-partner" replace />} />
        <Route path="/area-riservata/login" element={<ClienteLogin />} />
        <Route path="/area-riservata/registrati" element={<ClienteRegister />} />
        <Route path="/area-riservata/forgot-password" element={<ClienteForgotPassword />} />
        <Route path="/area-riservata/reset-password" element={<ClienteResetPassword />} />
        <Route path="/area-riservata" element={<AreaRiservata />} />
        <Route path="/preferiti" element={<Preferiti />} />
        <Route path="/contatti" element={<Contatti />} />
      </Routes>
    </div>
  );
}
